<template>
  <div>
    <div :class="groupClass">
      <label :class="lableClass" :for="name">
        <slot>{{ title }}</slot>
      </label>

      <div :class="fieldClass" class="no-min-width">
        <!--Special Part Starts-->
        <multiselect
          :custom-label="fullname"
          :disabled="!$lodash.has(customer, 'id')"
          :internal-search="false"
          :limit="3"
          :limit-text="limitText"
          :loading="!ready"
          :options="options"
          :options-limit="200"
          :searchable="true"
          :show-labels="false"
          :value="value"
          label="email"
          placeholder="Type to search"
          track-by="id"
          @input="update"
          @search-change="asyncFind"
        >
          <template #noResult>
            <slot name="no-result">Oops! No result found.</slot>
          </template>
        </multiselect>
        <!--Special Part Ends-->

        <div
          v-if="form && form.errors.has(errorId)"
          class="invalid-feedback"
          v-text="form.errors.get(errorId)"
        ></div>
        <slot name="note"></slot>
      </div>

      <div :class="extraSlotClass">
        <slot name="extra"></slot>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
import debounce from "debounce";
import BaseComponent from "./BaseComponent.vue";

export default {
  extends: BaseComponent,

  props: {
    customer: {
      default: null,
    },

    autoInit: {
      default: false,
    },

    autoPopulateIfSingle: {
      default: false,
    },
  },

  created() {
    if (this.autoInit) {
      this.init();
    }
  },

  methods: {
    init() {
      this.ready = false;

      if (this.form) {
        this.form.errors.clear(this.errorId);
      }

      this.$http.get(`/contacts?limit=50&customer_id=${this.customer.id}`).then((response) => {
        this.options = response.body.data;

        if (this.autoPopulateIfSingle) {
          this.populateIfSingle();
        }

        this.ready = true;
      });
    },

    populateIfSingle() {
      // Only populate if:
      // 1. only one contact exist for the customer, and
      // 2. the chosen value for this contact select is empty
      if (this.options && this.options.length === 1 && !this.$lodash.get(this.value, "id")) {
        this.update(this.options[0]);
      }
    },

    fullname(contact) {
      let name = "";

      if (contact.name) {
        /* eslint-disable prefer-destructuring */
        name = contact.name;
      }

      if (name.length > 0) {
        return name;
      }

      return "";
    },

    limitText(count) {
      return `and ${count} other contacts`;
    },

    /* eslint-disable func-names */
    asyncFind: debounce(function (query) {
      if (query.length < 2) {
        return;
      }

      this.ready = false;

      if (this.form) {
        this.form.errors.clear(this.errorId);
      }

      this.$http
        .get(
          `/contacts?search=${query}&searchFields=first_name:like;last_name:like&limit=50&customer_id=${this.customer.id}`
        )
        .then((response) => {
          this.options = response.body.data;
          this.ready = true;
        });
    }, 500),

    update(object) {
      if (object !== undefined && object !== null) {
        this.form[this.name] = object.id;
      }

      if (this.form) {
        this.form.errors.clear(this.errorId);
      }

      this.$emit("change", object);
    },
  },
};
</script>
